export const BOOKING_URL = `org/booking`;
export const BUYERS_URL = "org/buyers";
export const ADMIN_URL = "admin/org";
export const ADMIN_USER_URL = "admin/users";
export const ORG_USER_URL = "org/user";
export const ORG_USERS_URL = "org/users";
export const MARKETPLACE_URL = "api/marketplace";
export const OFFER_URL = "api/offer";
export const PROJECT_URL = `${BOOKING_URL}/project`;
export const BUYERS_LITE_URL = `${BUYERS_URL}/search/lite`;
export const ORDER_CODE_URL = `${BOOKING_URL}/order/code`;
export const PARCEl_NUMBER_URL = `${BOOKING_URL}/project`;
export const MARKETPLACE_ORDER_URL = `${MARKETPLACE_URL}/backOffice/orders`;
